import StorageKeys from "./StorageKeys";
import local from "./local";
import session from "./session";

export default {
	StorageKeys,
	...local,
	...session,
};
